import React from 'react';
import * as PropTypes from 'prop-types';
import trashIcon from '../../assets/img/icons/trash.svg';

const CommonDeleteIconButton = ({ handleClick, className, dataStep, dataIndex }) => {
  return (
    <div className={`common-delete-button__icon-wrapper ${className}`}>
      <button
        type="button"
        data-step={dataStep}
        data-index={dataIndex}
        className="d-flex justify-content-center align-items-center w-100"
        onClick={handleClick}
      >
        <img src={trashIcon} alt="alt" />
      </button>
    </div>
  );
};

CommonDeleteIconButton.defaultProps = {
  handleClick: null,
  className: '',
  dataStep: null,
  dataIndex: null,
};

CommonDeleteIconButton.propTypes = {
  handleClick: PropTypes.func,
  className: PropTypes.string,
  dataStep: PropTypes.number,
  dataIndex: PropTypes.number,
};

export default CommonDeleteIconButton;
